/**
 * Central custom icon registry for re_web_client.
 *
 * Icons live in:
 *   src/assets/icons/sharedIcons/
 *
 * Usage:
 *   import { AppIcon } from "components/AppIcon";
 *   import type { IconName } from "assets/icons";
 *
 *   <AppIcon name="building" size={24} alt="Brokerages" />
 *   <AppIcon name="salesOrder" size={22} />
 */

import AgentInventoryIcon from "assets/icons/sharedIcons/Agent Inventory.svg";
import AgentIcon from "assets/icons/sharedIcons/Agent.svg";
import OfficeInventoryIcon from "assets/icons/sharedIcons/Office inventory.svg";
import OutstandingBalanceIcon from "assets/icons/sharedIcons/Outstanding Balance.svg";
import RemovalRevenueIcon from "assets/icons/sharedIcons/Removal revenue.svg";
import SalesOrderIcon from "assets/icons/sharedIcons/Sales Order.svg";
import TotalOrdersIcon from "assets/icons/sharedIcons/Total Orders.svg";
import TotalRevenueIcon from "assets/icons/sharedIcons/Total Revenue.svg";
import BuildingIcon from "assets/icons/sharedIcons/building.svg";
import CheckIcon from "assets/icons/sharedIcons/check.svg";
import DollarIcon from "assets/icons/sharedIcons/dollar.svg";
import OfficeIcon from "assets/icons/sharedIcons/office.svg";
import PaidBillIcon from "assets/icons/sharedIcons/paid-bill (1).svg";
import ProfitIcon from "assets/icons/sharedIcons/profit.svg";
import TeamIcon from "assets/icons/sharedIcons/team.svg";
import WarehouseIcon from "assets/icons/sharedIcons/warehouse.svg";

// --- order details ---
import User4Icon from "assets/icons/sharedIcons/user 4.svg";
import BillingIcon from "assets/icons/sharedIcons/billing.svg";
import ShippingAddressIcon from "assets/icons/sharedIcons/shipping address 2.svg";
import OrderLogIcon from "assets/icons/sharedIcons/Order Log 2.svg";
import ShippingTruckIcon from "assets/icons/sharedIcons/Vector.svg";
import ShippingOptionsIcon from "assets/icons/sharedIcons/shipping-Options 2.svg";
import Dollar3Icon from "assets/icons/sharedIcons/dollar 3.svg";
import PaymentMethodIcon from "assets/icons/sharedIcons/Payment method 2.svg";
import PaymentDetailsIcon from "assets/icons/sharedIcons/Payment details 2.svg";
import Box3Icon from "assets/icons/sharedIcons/box 3.svg";
import Proof2Icon from "assets/icons/sharedIcons/Proof 2.svg";
import Instruction3Icon from "assets/icons/sharedIcons/Instruction 3.svg";
import Instruction4Icon from "assets/icons/sharedIcons/Instruction 4.svg";
import OrderDetailsIcon from "assets/icons/sharedIcons/Order Details.svg";
import ProjectsIcon from "assets/icons/sharedIcons/projects.svg";

// --- signagesidebaricons ---
import SidebarBusinessIcon from "assets/icons/sharedIcons/signagesidebaricons/Business.svg";
import SidebarDashboardIcon from "assets/icons/sharedIcons/signagesidebaricons/Dashboard.svg";
import SidebarFinanceIcon from "assets/icons/sharedIcons/signagesidebaricons/Finance 2.svg";
import SidebarIncomingIcon from "assets/icons/sharedIcons/signagesidebaricons/Inoming 1.svg";
import SidebarJobsIcon from "assets/icons/sharedIcons/signagesidebaricons/Jobs 2.svg";
import SidebarOrdersIcon from "assets/icons/sharedIcons/signagesidebaricons/Order & Fufillment 1.svg";
import SidebarPostTypesIcon from "assets/icons/sharedIcons/signagesidebaricons/Post Types 1.svg";
import SidebarProductsIcon from "assets/icons/sharedIcons/signagesidebaricons/Products & Inventory 1.svg";
import SidebarProjectsIcon from "assets/icons/sharedIcons/signagesidebaricons/Projects 1.svg";
import SidebarReportsIcon from "assets/icons/sharedIcons/signagesidebaricons/Reports 2.svg";
import SidebarShipmentsIcon from "assets/icons/sharedIcons/signagesidebaricons/Shipping 2.svg";
import SidebarStudioIcon from "assets/icons/sharedIcons/signagesidebaricons/Studio 1.svg";
import SidebarWorkDriveIcon from "assets/icons/sharedIcons/signagesidebaricons/folder01 1.svg";
import SidebarConfigurationIcon from "assets/icons/sharedIcons/signagesidebaricons/Configurations 1.svg";
import SidebarProfileIcon from "assets/icons/sharedIcons/signagesidebaricons/Profile.svg";
import SidebarIntegrationsIcon from "assets/icons/sharedIcons/signagesidebaricons/integration 2.svg";
import SidebarLogoutIcon from "assets/icons/sharedIcons/signagesidebaricons/log out.svg";
import SidebarMarketplaceIcon from "assets/icons/sharedIcons/signagesidebaricons/marketplace-alt 2.svg";

export const SharedIcons = {
  agentInventory: AgentInventoryIcon,
  agent: AgentIcon,
  officeInventory: OfficeInventoryIcon,
  outstandingBalance: OutstandingBalanceIcon,
  removalRevenue: RemovalRevenueIcon,
  salesOrder: SalesOrderIcon,
  totalOrders: TotalOrdersIcon,
  totalRevenue: TotalRevenueIcon,
  building: BuildingIcon,
  check: CheckIcon,
  dollar: DollarIcon,
  office: OfficeIcon,
  paidBill: PaidBillIcon,
  profit: ProfitIcon,
  team: TeamIcon,
  warehouse: WarehouseIcon,
  customerDetails: User4Icon,
  billingAddress: BillingIcon,
  shippingAddress: ShippingAddressIcon,
  orderLog: OrderLogIcon,
  shippingTruck: ShippingTruckIcon,
  shippingOptions: ShippingOptionsIcon,
  dollar3: Dollar3Icon,
  paymentMethod: PaymentMethodIcon,
  paymentDetails: PaymentDetailsIcon,
  productBox: Box3Icon,
  proof: Proof2Icon,
  instruction: Instruction3Icon,
  instruction4: Instruction4Icon,
  orderDetails: OrderDetailsIcon,
  projects: ProjectsIcon,
  sidebarBusiness: SidebarBusinessIcon,
  sidebarDashboard: SidebarDashboardIcon,
  sidebarFinance: SidebarFinanceIcon,
  sidebarIncoming: SidebarIncomingIcon,
  sidebarJobs: SidebarJobsIcon,
  sidebarOrders: SidebarOrdersIcon,
  sidebarPostTypes: SidebarPostTypesIcon,
  sidebarProducts: SidebarProductsIcon,
  sidebarProjects: SidebarProjectsIcon,
  sidebarReports: SidebarReportsIcon,
  sidebarShipments: SidebarShipmentsIcon,
  sidebarStudio: SidebarStudioIcon,
  sidebarWorkDrive: SidebarWorkDriveIcon,
  sidebarConfiguration: SidebarConfigurationIcon,
  sidebarProfile: SidebarProfileIcon,
  sidebarIntegrations: SidebarIntegrationsIcon,
  sidebarLogout: SidebarLogoutIcon,
  sidebarMarketplace: SidebarMarketplaceIcon,
} as const;

export type IconName = keyof typeof SharedIcons;

/** Alias used by AppIcon (same registry). */
export const HomeIcons = SharedIcons;
